var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loading-mask",style:({ backgroundColor: _vm.backgroundColor })},[_c('vue-loading',{attrs:{"type":"spiningDubbles","color":"#efad4c","size":{ width: '100px', height: '100px' }}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }